import { SUBTYPE_OPTS, time, getSuper, bindPrototype, assignPrivateSymbol, setSymbols, getSymbols, iu, initAbstract, construct, $combine, subtype, implementEngineer, $skip, makeClassSymbol } from '@type.engineering/type-engineer'
import './typedefs'
import '../../../types'
import { BuildingBlock, Concealed, proxifyState, setupClassSeers, control } from '@mauriceguest/guest'

/**
 * @abstract
 * @extends {ru.hulkmoto.CalendarHeadingController}
 */
class _AbstractCalendarHeadingController {
 constructor() {
  construct(this)
 }
 /** @nocollapse */
 static control(el, opts) {
  const AllSymbols = CalendarHeadingControllerSymbols
  /** @suppress {checkTypes} */
  const res = control(this, el, opts, AllSymbols)
  return /** @type {!ru.hulkmoto.CalendarHeadingController} */ (res)
 }
}
/**
 *         A single heading cell in the calendar. Its inner text value can change
 * based on outside conditions (e.g., what tariff is selected).
 * @extends {ru.hulkmoto.CalendarHeadingController} ‎
 * @implements {ru.hulkmoto.ICalendarHeadingController} ‎
 */
export class AbstractCalendarHeadingController extends _AbstractCalendarHeadingController {

}
initAbstract(_AbstractCalendarHeadingController, 'ICalendarHeadingController', /** @this {AbstractCalendarHeadingController} */ function () {
 const { superStateful: { setState, initialState } } = this
 const state = {
  headings: null,
  ...initialState,
 }
 proxifyState(state)
 setState(state)
 const { superProper: { setProps, initialProps } } = this
 const props = {
  i: 0,
  ...initialProps,
 }
 proxifyState(props)
 setProps(props)
})
/** @constructor @extends {_AbstractCalendarHeadingController} @suppress {checkTypes} */ function __AbstractCalendarHeadingController() {}
__AbstractCalendarHeadingController.prototype = /** @type {!_AbstractCalendarHeadingController} */ ({
 get asICalendarHeadingController() {
  return /** @type {!ru.hulkmoto.BoundICalendarHeadingController} */ (this)
 },
 get superICalendarHeadingController() {
  return /** @type {!ru.hulkmoto.BoundICalendarHeadingController} */ (bindPrototype(_AbstractCalendarHeadingController, this))
 },
 get superCalendarHeadingController() {
  return /** @type {!ru.hulkmoto.BoundCalendarHeadingController} */ (bindPrototype(_AbstractCalendarHeadingController, this))
 },
})
export const CalendarHeadingControllerSymbols = {
 __: makeClassSymbol(AbstractCalendarHeadingController, '__'),
}

/** @type {ru.hulkmoto.getCalendarHeadingControllerSymbols} */
export const getCalendarHeadingControllerSymbols = (instance) => {
 return /** @type {!ru.hulkmoto.ICalendarHeadingControllerSymbolsOut} */ (getSymbols(instance, CalendarHeadingControllerSymbols))
}
/** @type {ru.hulkmoto.setCalendarHeadingControllerSymbols} */
export const setCalendarHeadingControllerSymbols = (instance, symbols) => {
 setSymbols(instance, symbols, CalendarHeadingControllerSymbols)
}

AbstractCalendarHeadingController.__implement(__AbstractCalendarHeadingController, BuildingBlock)
